import { read } from "fs";
import { lazy } from "react";
import { Server } from "react-feather";

const PermissionPOST = lazy(() =>
  import("../../../views/App/Setup/Permissions/post")
);
const Permission = lazy(() => import("../../../views/App/Setup/Permissions"));
const Role = lazy(() => import("../../../views/App/Setup/Role"));
const User = lazy(() => import("../../../views/App/Setup/User"));
const AppSetting = lazy(() => import('../../../views/App/Setup/AccountSetting'))
const PrintCustom = lazy(() => import('../../../views/App/Setup/PrintCustomization/index')) 
const NewPrint= lazy(() => import('../../../views/App/Setup/PrintCustomization/post'))
const Services = lazy(() => import('../../../views/App/Setup/Services'))
const VideoCategory = lazy(() => import('../../../views/App/Setup/VideoCategory'))
const Instructores = lazy(() => import('../../../views/App/Setup/Instructores'))
const Talents = lazy(() => import('../../../views/App/Setup/Talents'))
const Members = lazy(() => import('../../../views/App/Setup/Members'))
const Appointments = lazy(() => import('../../../views/App/Setup/Appointments'))
const Chat = lazy(() => import('../../../views/App/Setup/chat'))
const Video = lazy(() => import('../../../views/App/Setup/Video/index'))
const Notification = lazy(() => import('../../../views/App/Setup/Notification/index'))
const NewVideo = lazy(() => import('../../../views/App/Setup/Video/post'))
const VideoCall = lazy(() => import('../../../views/App/Setup/chat/Call.js'))
const Sesssions = lazy(() => import('../../../views/App/Setup/Session/index'))
const ViewTalent = lazy(() => import('../../../views/App/Setup/Talents/View'))
const Notfications = lazy(() => import('../../../views/App/Setup/Notfications'))
const Survey = lazy(() => import("../../../views/App/Setup/Survey/index.js"));
const NewSurvey = lazy(() => import("../../../views/App/Setup/Survey/post.js"));

export default [
  {
    path: "/Setup/User",
    element: <User />,
    meta: {
      action: "read",
      resource: "Doctype-9",
    },
  },
  {
    path: "/Setup/Notification",
    element: <Notification />,
    meta: {
      action: "read",
      resource: "Doctype-9",
    },
  },
  {
    path: "/Setup/Role",
    element: <Role />,
    meta: {
      action: "read",
      resource: "Doctype-1",
    },
  },
  {
    path: "/Setup/Chat",
    element: <Chat />,
    meta: {
      action: "read",
      resource: "Doctype-3",
    },
  },

  {
    path: "/Setup/Permission",
    element: <Permission />,
    meta: {
      action: "read",
      resource: "Doctype-6",
    },
  },
  {
    path: "/Setup/NewPermission",
    element: <PermissionPOST />,
    meta: {
      action: "read",
      resource: "Doctype-6",
    },
  },
  {
    path: "/Setup/UpdatePermission/:series",
    element: <PermissionPOST />,
    meta: {
      action: "read",
      resource: "Doctype-6",
    },
  },
  {
    path: "/Setup/AppSetting",
    element: <AppSetting />,
    meta: {
      action: "read",
      resource: "DT-7",
    },
  },
  {
    path: "/Setting/PrintCustomization",
    element: <PrintCustom />,
    meta: {
      action: "read",
      resource: "DT-7",
    },
  },
  {
    path: "/Setting/UpdatePrintCustomization/:series/:name/:doctype/:isRtl/:isReciept/:isDefault/:isLandscape",
    element: <NewPrint />,
    meta: {
      action: "read",
      resource: "DT-9",
    },
  },
  {
    path: "/Setting/NewPrintCustomization/:name/:doctype/:isRtl/:isReciept",
    element: <NewPrint />,
    meta: {
      action: "read",
      resource: "DT-9",
    },
  },
  {
    path: "/Setup/VideoCategory",
    element: <VideoCategory />,
    meta: {
      action: "read",
      resource: "Doctype-11",
    },
  },
  {
    path: "/Setup/Survey",
    element: <Survey />,
    meta: {
      action: "read",
      resource: "Doctype-11",
    },
  },
  {
    path: "/Setup/NewSurvey",
    element: <NewSurvey />,
    meta: {
      action: "read",
      resource: "Doctype-11",
    },
  },
  {
    path: "/Setup/UpdateSurvey/:series",
    element: <NewSurvey />,
    meta: {
      action: "read",
      resource: "Doctype-11",
    },
  },

  // {
  //     path: "/Setup/Template",
  //     element: <Setup_Template />,
  //     meta: {
  //         action: "read",
  //         resource: "DT-3",
  //     },
  // },
  {
    path: "/Setup/Services",
    element: <Services />,
    meta: {
      action: "read",
      resource: "Doctype-7",
    },
  },
  {
    path: "/Setup/Instructores",
    element: <Instructores />,
    meta: {
      action: "read",
      resource: "Doctype-4",
    },
  },
  {
    path: "/Setup/Talents",
    element: <Talents />,
    meta: {
      action: "read",
      resource: "Doctype-8",
    },
  },
  {
    path: "/Setup/Members",
    element: <Members />,
    meta: {
      action: "read",
      resource: "Doctype-5",
    },
  },
  {
    path: "/Setup/Appointments",
    element: <Appointments />,
    meta: {
      action: "read",
      resource: "Doctype-2",
    },
  },
  {
    path: "/Setup/Video",
    element: <Video />,
    meta: {
      action: "read",
      resource: "Doctype-10",
    },
  },
  {
    path: "/Setup/NewVideo",
    element: <NewVideo />,
    meta: {
      action: "read",
      resource: "Doctype-10",
    },
  },
  {
    path: "/Setup/UpdateVideo/:series",
    element: <NewVideo />,
    meta: {
      action: "read",
      resource: "Doctype-10",
    },
  },
  {
    path: "/Setup/VideoCall/:series",
    element: <VideoCall />,
    meta: {
      action: "read",
      resource: "DT-3",
    },
  },
  {
    path: "/Setup/Sesssions",
    element: <Sesssions />,
    meta: {
      action: "read",
      resource: "Doctype-15",
    },
  },
  {
    path: "/Setup/ViewTalent/:series",
    element: <ViewTalent />,
    meta: {
      action: "read",
      resource: "Doctype-8",
    },
  },
  {
    path: "/Setup/Notfications",
    element: <Notfications />,
    meta: {
      action: "read",
      resource: "Doctype-8",
    },
  },
];
